/** console.time-style hydration metrics — filter [startup] in DevTools. */
const active = new Set();

export function perfTimeStart(label) {
  if (active.has(label)) return;
  active.add(label);
  if (typeof console !== 'undefined' && console.time) {
    console.time(`[startup] ${label}`);
  }
}

export function perfTimeEnd(label) {
  if (!active.has(label)) return;
  active.delete(label);
  if (typeof console !== 'undefined' && console.timeEnd) {
    try {
      console.timeEnd(`[startup] ${label}`);
    } catch (_) {
      // duplicate end on hot reload
    }
  }
}
